import styled from 'styled-components';

export const HeroContainer = styled.div`
background: #0c0c0c;
display: flex;
justify-content: center;
align-items: center;
padding: 0 30px;
height: 800px;
position: relative;
z-index: 1;

`;


export const HeroBg = styled.div`
position:absolute;
top:0;
right:0;
bottom:0;
left:0;
width:100%;
height: 100%;
overflow: hidden; 

`;

export const VideoBg = styled.video`
width:100%;
height: 100%;
-o-object-fit: cover;
object-fit: cover;
background: #232a34;
opacity: 0.4;

`;

export const HeroContent = styled.div`
z-index:1;
color: white;
text-align: center;
align-items: center;
margin: 20px;
padding: 20px;
opacity: 0.9;
border-radius: 20px;


`;

export const HeroH1 = styled.h1`
font-size: 65px;

`;

export const HeroP = styled.p`
font-size: 30px;


`;



